export type MapMode = "bhop" | "surf" | "kz";
export function mapMode(map: {id: string; mode?: MapMode}): MapMode {
  return map.mode ?? (map.id.startsWith("surf_") ? "surf" : map.id.startsWith("kz_") ? "kz" : "bhop");
}
